export const PACKAGE_DISCOUNT_OPTIONS = [10, 15, 20, 25, 30] as const;

export type PackageDiscountPercent = (typeof PACKAGE_DISCOUNT_OPTIONS)[number];

export const DEFAULT_PACKAGE_DISCOUNT_PERCENT: PackageDiscountPercent = 20;

const STORAGE_PREFIX = "adatis.packageSuggestedDiscountPercent";

const storageKey = (tenantId: number): string => `${STORAGE_PREFIX}.${tenantId}`;

const isValidPercent = (value: number): value is PackageDiscountPercent =>
  (PACKAGE_DISCOUNT_OPTIONS as readonly number[]).includes(value);

export const getPackageSuggestedDiscountPercent = (
  tenantId: number
): PackageDiscountPercent => {
  if (typeof window === "undefined" || tenantId <= 0) {
    return DEFAULT_PACKAGE_DISCOUNT_PERCENT;
  }

  try {
    const raw = localStorage.getItem(storageKey(tenantId));
    if (!raw) {
      return DEFAULT_PACKAGE_DISCOUNT_PERCENT;
    }

    const parsed = Number(raw);
    return isValidPercent(parsed) ? parsed : DEFAULT_PACKAGE_DISCOUNT_PERCENT;
  } catch {
    return DEFAULT_PACKAGE_DISCOUNT_PERCENT;
  }
};

export const setPackageSuggestedDiscountPercent = (
  tenantId: number,
  percent: PackageDiscountPercent
): void => {
  if (typeof window === "undefined" || tenantId <= 0) {
    return;
  }

  try {
    localStorage.setItem(storageKey(tenantId), String(percent));
  } catch {
    // localStorage unavailable
  }
};
